module.exports = __webpack_public_path__ + "img/solar.29044569.svg";